// NAV-002's home route (`/`, signed-in landing), composed into the route table by TASK-140.
// SCR-002's own NAV-002 route (`/signin`, public) is registered by screens/signin.
import { defineRoute, type ScreenRoute } from "../../router/route";
import { HOME_PATH } from "./model";
import { Home } from "./home";

export const routes: ScreenRoute[] = [
  defineRoute({ nav: "NAV-002", path: HOME_PATH, title: "Overview", permission: "signed-in", component: Home }),
];
